import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlashIconIsOn = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.7191 6.0901V9.1801H3.51913C1.83913 9.1801 1.49913 10.0901 2.75913 11.2001L11.3591 18.7701C12.4091 19.7001 13.2791 19.3101 13.2791 17.9001V14.8101H20.4791C22.1591 14.8101 22.4991 13.9001 21.2391 12.7901L12.6391 5.2201C11.5791 4.3001 10.7191 4.6901 10.7191 6.0901Z",
		stroke: "white",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFlashIconIsOn;
